module.exports = __webpack_public_path__ + "static/media/check_mark.232c0ee2.svg";